import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dbaas',
  templateUrl: './dbaas.component.html',
  styleUrls: ['./dbaas.component.css']
})
export class DbaasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // Check font loading after component is loaded
    this.checkFontLoading();
  }

  checkFontLoading() {
    // Simple check after component is loaded
    setTimeout(() => {
      // Create a test element to check if Boxicons font is loaded
      const testElement = document.createElement('span');
      testElement.className = 'bx bxl-mysql';
      testElement.style.position = 'absolute';
      testElement.style.left = '-9999px';
      testElement.style.fontFamily = 'boxicons';
      testElement.textContent = 'test';
      
      document.body.appendChild(testElement);
      
      // Check if the font is loaded after a short delay
      setTimeout(() => {
        const computedStyle = window.getComputedStyle(testElement);
        const fontFamily = computedStyle.fontFamily;
        
        // If the font family is not boxicons, it means the font failed to load
        if (!fontFamily.includes('boxicons')) {
          // Add a class to indicate font loading failure
          document.body.classList.add('boxicons-failed');
        }
        
        // Clean up
        document.body.removeChild(testElement);
      }, 100);
    }, 500);
  }
}
